// extracted by mini-css-extract-plugin
module.exports = {"table":"StockTable_table__NI9zW"};